import type { FormRule } from 'antd';
import { isSafeIntValidator } from 'shared/utils/validators/is-safe-integer-validator';

export const getCargoItemFieldsRule = (isStackRequired = false): Record<string, FormRule[]> => ({
  count: [
    { required: true, message: 'Count is required' },
    { type: 'integer', min: 1, message: 'Count must be a positive integer' },
  ],
  length: [
    { required: true, message: 'Length is required' },
    { type: 'number', min: 0.1, max: 14, message: 'Length must be between 0.1 and 14 meters' },
  ],
  width: [
    { required: true, message: 'Width is required' },
    { type: 'number', min: 0.1, max: 2.5, message: 'Width must be between 0.1 and 2.5 meters' },
  ],
  height: [
    { required: true, message: 'Height is required' },
    { type: 'number', min: 0.1, max: 3, message: 'Height must be between 0.1 and 3 meters' },
  ],
  weight: [{ type: 'integer', min: 1, message: 'Weight must be a positive integer' }, ...isSafeIntValidator('Weight')],
  stack: isStackRequired
    ? [
        { required: true, message: 'Stack is required' },
        { type: 'integer', min: 1, message: 'Stack must be a positive integer' },
        ...isSafeIntValidator('Stack'),
      ]
    : [{ type: 'integer', min: 1, message: 'Stack must be a positive integer' }, ...isSafeIntValidator('Stack')],
});
